import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { css } from '@emotion/core';
import { easeOut, prefersReducedMotion } from '@atlaskit/motion';
import { BANNER, BANNER_HEIGHT, CONTENT, IS_SIDEBAR_DRAGGING, LEFT_PANEL, LEFT_PANEL_WIDTH, RIGHT_PANEL, RIGHT_PANEL_WIDTH, RIGHT_SIDEBAR_WIDTH, TOP_NAVIGATION, TOP_NAVIGATION_HEIGHT, TRANSITION_DURATION } from '../../common/constants';
var gridTemplateAreas = "\n  \"".concat(LEFT_PANEL, " ").concat(BANNER, " ").concat(RIGHT_PANEL, "\"\n  \"").concat(LEFT_PANEL, " ").concat(TOP_NAVIGATION, " ").concat(RIGHT_PANEL, "\"\n  \"").concat(LEFT_PANEL, " ").concat(CONTENT, " ").concat(RIGHT_PANEL, "\"\n ");
export var gridStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  outline: none;\n\n  display: grid;\n  height: 100%;\n  // prettier-ignore\n  grid-template-columns: ", " minmax(0, 1fr) ", ";\n  grid-template-rows:\n    ", " ", "\n    auto;\n  grid-template-areas: ", ";\n"])), LEFT_PANEL_WIDTH, RIGHT_PANEL_WIDTH, BANNER_HEIGHT, TOP_NAVIGATION_HEIGHT, gridTemplateAreas);
export var contentStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  grid-area: ", ";\n  display: flex;\n  height: 100%;\n  position: relative;\n"])), CONTENT);
export var focusStyles = {
  '&:focus': {
    outline: 'none',
    '&  [data-wrapper-element]': {
      outline: 'none',
      boxShadow: '0px 0px 0px 2px inset #4C9AFF'
    },
    '& > div:not([data-skip-link-wrapper])': {
      outline: 'none',
      boxShadow: '0px 0px 0px 2px inset #4C9AFF'
    }
  }
};
export var bannerStyles = function bannerStyles(isFixed) {
  return _objectSpread(_objectSpread({
    gridArea: "".concat(BANNER),
    height: "".concat(BANNER_HEIGHT)
  }, focusStyles), isFixed && {
    position: 'fixed',
    top: 0,
    left: "".concat(LEFT_PANEL_WIDTH),
    right: "".concat(RIGHT_PANEL_WIDTH),
    zIndex: 2
  });
};
export var topNavigationStyles = function topNavigationStyles(isFixed) {
  return _objectSpread(_objectSpread({
    gridArea: "".concat(TOP_NAVIGATION),
    height: "".concat(TOP_NAVIGATION_HEIGHT)
  }, focusStyles), isFixed && {
    position: 'fixed',
    top: "".concat(BANNER_HEIGHT),
    left: "".concat(LEFT_PANEL_WIDTH),
    right: "".concat(RIGHT_PANEL_WIDTH),
    zIndex: 2
  });
};
export var mainStyles = _objectSpread(_objectSpread({}, focusStyles), {}, _defineProperty({
  // Prevent flex container from blowing
  // up when there's super wide content
  flexGrow: 1,
  minWidth: 0,
  // Transition negative margin on main
  // in sync with the increase in width of
  // leftSidebar
  transition: "margin-left ".concat(TRANSITION_DURATION, "ms ").concat(easeOut, " 0s"),
  marginLeft: 0
}, "[".concat(IS_SIDEBAR_DRAGGING, "] &"), {
  // Make sure drag to resize remains snappy
  transition: 'none',
  cursor: 'ew-resize'
}), prefersReducedMotion()); // This inner wrapper is required to allow the
// sidebar to be position: fixed. If we were to apply position: fixed
// to the outer wrapper, it will be popped out of it's flex container
// and Main would stretch to occupy all the space.

export var fixedRightSidebarInnerStyles = function fixedRightSidebarInnerStyles(isFixed) {
  return _objectSpread(_objectSpread({}, focusStyles), isFixed ? {
    position: 'fixed',
    top: "calc(".concat(BANNER_HEIGHT, " + ").concat(TOP_NAVIGATION_HEIGHT, ")"),
    right: "calc(".concat(RIGHT_PANEL_WIDTH, ")"),
    bottom: 0
  } : {
    height: '100%'
  });
};
export var rightSidebarStyles = function rightSidebarStyles(isFixed) {
  return _objectSpread(_objectSpread({
    width: "".concat(RIGHT_SIDEBAR_WIDTH)
  }, focusStyles), isFixed && {
    // in fixed mode this element's child is taken out of the document flow
    // It doesn't take up the width as expected
    // psuedo element forces it to take up the necessary width
    '&::after': {
      content: "''",
      display: 'inline-block',
      width: "".concat(RIGHT_SIDEBAR_WIDTH)
    }
  });
};
export var rightPanelStyles = function rightPanelStyles(isFixed) {
  return _objectSpread(_objectSpread({
    gridArea: RIGHT_PANEL
  }, focusStyles), isFixed && {
    position: 'fixed',
    width: "".concat(RIGHT_PANEL_WIDTH),
    top: 0,
    bottom: 0,
    right: 0
  });
};
export var leftPanelStyles = function leftPanelStyles(isFixed) {
  return _objectSpread(_objectSpread({
    gridArea: LEFT_PANEL
  }, focusStyles), isFixed && {
    position: 'fixed',
    width: "".concat(LEFT_PANEL_WIDTH),
    top: 0,
    bottom: 0,
    left: 0
  });
};